import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LogoContainer = styled(Link)``

export const LogoImg = styled.img`
  height: 100%;
  width: auto;
`
